module.exports = __webpack_public_path__ + "media/audio1.a4b59e8f.mp3";